export const NAME = 'panels';
export const COLUMNS_CONFIG = {
    brand: {
        label: 'Brand',
        is_active: true,
        required: false,
    },
    code: {
        label: 'Code',
        is_active: true,
        required: false,
    },
    product_type: {
        label: 'Type',
        is_active: true,
        required: false,
    },
    max_power: {
        label: 'Potency',
        is_active: true,
        required: false,
    },
    name: {
        label: 'Name',
        is_active: true,
        required: true,
    },
    height: {
        label: 'Length',
        is_active: false,
        required: false,
    },
    width: {
        label: 'Width',
        is_active: false,
        required: false,
    },
    depth: {
        label: 'Thickness',
        is_active: false,
        required: false,
    },
};
